import * as React from "react";
const SvgArrowUpRightLine = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M5 19L19 5M19 16V5H8", stroke: "currentColor", strokeWidth: 2.25 }));
export default SvgArrowUpRightLine;
